
import { Component, Vue } from 'vue-property-decorator'

import userModule from '@/store/user'
import ContentList from '@/components/listView/ContentList.vue'
import { ListType } from '@/utils/enums'
import { User } from '@/types/User'
import UserImport from './UserImport.vue'
import whitelabel from '@/store/whitelabel'

@Component({
  name: 'UserList',
  components: {
    ContentList,
    UserImport
  }
})
class UserList extends Vue {
  public listType = ListType
  public showEditor = false
  showImportDialog = false

  public get storeModule() {
    return userModule
  }

  public get users(): User[] {
    return userModule.users
  }

  public get headers() {
    return [
      { text: 'Vorname', value: 'firstName' },
      { text: 'E-Mail', value: 'email' },
      ...(whitelabel.whitelabel.flags.externalIds
        ? [{ text: 'Externe ID', value: 'externalId' }]
        : []),
      { text: 'Geschlecht', value: 'gender' },
      { text: 'Geburtsdatum', value: 'birthDate' },
      { text: 'Registrierungsdatum', value: 'createdAt' },
      { text: 'Rewardpunkte', value: 'points' },
      { text: 'Level', value: 'points' },
      { text: 'Promotioncode', value: 'promotionCode' },
      { text: 'Geschäfte', value: 'venues' },
      { text: 'Entfernen', value: 'actionDelete', sortable: false }
    ]
  }

  public get filters(): string[] {
    return ['gender', 'birthDate', 'createdAt', 'points']
  }

  public deleteUser(user: any) {
    userModule.delete({ userId: user._id })
  }
}

export default UserList
